import React from 'react';
import { ChartLine, Bank, CreditCard, Calculator, Handshake, Files, Bell, Buildings } from '@phosphor-icons/react';
import PublicSiteLayout from '../components/PublicSiteLayout';

const features = [
  { icon: ChartLine, title: 'Investment Tracking', description: 'Track NEPSE buy and sell activity, holdings, buying price, and profit visibility.' },
  { icon: Bank, title: 'Accounts Overview', description: 'Manage bank, cash, and payment gateway balances from one place.' },
  { icon: CreditCard, title: 'Payment Planning', description: 'Handle bills, recurring payments, and due dates with reminders.' },
  { icon: Calculator, title: 'EMI Management', description: 'Track EMI schedules, monthly commitments, and next payment dates.' },
  { icon: Handshake, title: 'Lend / Borrow', description: 'Record money lent out or borrowed and monitor pending balances clearly.' },
  { icon: Files, title: 'Printable Reports', description: 'Generate section-wise date-filtered reports and print them to PDF.' },
  { icon: Bell, title: 'Upcoming Alerts', description: 'See important events due within 7 days directly from the top bar.' },
  { icon: Buildings, title: 'Property Records', description: 'Store property and asset value snapshots as part of your full net worth view.' },
];

export default function PublicFeaturesPage() {
  return (
    <PublicSiteLayout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#7A766E]">Features</p>
          <h1 className="mt-3 text-4xl md:text-5xl font-extrabold tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Everything organized around practical money management.
          </h1>
          <p className="mt-5 text-lg text-[#5C5A56] leading-8">
            Spell FinX is built for people who want one structured place for cashflow, investments, liabilities, reminders, and printable financial records.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 xl:grid-cols-4 gap-5">
          {features.map(({ icon: Icon, title, description }) => (
            <div key={title} className="bg-white border border-[#E8E6E1] rounded-3xl p-6 shadow-sm">
              <div className="w-12 h-12 rounded-2xl bg-[#1E3F2D]/10 flex items-center justify-center">
                <Icon size={22} weight="fill" className="text-[#1E3F2D]" />
              </div>
              <h2 className="mt-5 text-lg font-bold text-[#1C1B1A]">{title}</h2>
              <p className="mt-3 text-sm leading-7 text-[#5C5A56]">{description}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicSiteLayout>
  );
}
